import React from "react";
import { Box, Typography, Grid, Card, CardContent, Avatar, IconButton } from "@mui/material";
import {
    People,
    Event,
    Stars,
    Public,
    SupportAgent,
    Verified,
    PersonSearch,
    WorkspacePremium,
    StarBorder,
} from "@mui/icons-material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import StarIcon from "@mui/icons-material/Star";

export default function AboutPage() {
    const sectionStyle = {
        background: "#f7f7f7",
        padding: { xs: "20px 30px", md: "40px 60px" },
        borderRadius: "16px",
        marginBottom: "40px",
    };

    const headingStyle = {
        color: "#BF0603",
        fontWeight: 700,
        fontFamily: "quicksand",
        marginBottom: "20px",
        textAlign: "center",
        fontSize: { xs: "24px", md: "38px" }
    };

    const subHeadingStyle = {
        color: "#f35b04",
        fontWeight: 600,
        fontFamily: "quicksand",
        marginBottom: "50px",
        fontSize: { xs: "22px", md: "32px" },
        textAlign: "center"
    };

    const textStyle = {
        color: "#000",
        lineHeight: 1.7,
        fontSize: "16px",
        marginBottom: "10px",
    };

    const cardIcon = {
        fontSize: 40,
        color: "#f35b04",
        marginBottom: "10px",
    };

    const achievementCard = {
        borderRadius: "16px",
        minHeight: "150px",
        display: "flex",
        alignItems: "center",
    };

    const reviews = [
        {
            name: "MUTHUSELVI MUTHUSAMY",
            img: "/mnt/data/6ec2e6b7-62ec-459a-a6fb-1105eeb2d512.png",
            stars: 5,
            time: "2 months ago",
            text: "Good Collections of Bride and I got good service .. well maintained office.",
        },
        {
            name: "Poos Ganesh",
            img: "/mnt/data/74b97378-6a8c-4e4a-a4ef-15c6071d7e25.png",
            stars: 4,
            time: "1 year ago",
            text: "Really it’s good services provided by them my friend got fixed marriage and they are providing trustworthy profile they frequently send profile according to our taste and willingnesses.",
        },
        {
            name: "Saraswathi MC",
            img: "/mnt/data/175006a4-c231-4cdf-87e5-8472016ec286.png",
            stars: 5,
            time: "1 year ago",
            text: "I'm Priyadharshini, My reg No :517. I recently got married by Vivaha Sangamam, A genuine service and quick responses from staffs.",
        },
        {
            name: "sakthi krish",
            img: "/mnt/data/0f440571-bc0a-4dda-a6f6-bc85ef7d40cd.png",
            stars: 5,
            time: "1 year ago",
            text: "I'm Shakthivel, My reg no: 5236. Vivaha Sangamam has the best service compared to other matrimony's. Marriage fixed within 3 months.",
        },
        {
            name: "MS PRIYAN",
            img: "/mnt/data/95e7d3f6-dc0e-4098-8e64-79bdc9df183d.png",
            stars: 5,
            time: "1 year ago",
            text: "My Registration no 9692 Viswa Linga Surya. Got good support from Vivaha sangamam and arranged assisted service. My search of Bride ended here.",
        },
    ];

    return (
        <Box sx={{ padding: { xs: "20px", md: "60px" }, marginTop: "100px" }}>
            {/* ABOUT US */}
            <Box sx={sectionStyle}>
                <Typography variant="h4" sx={headingStyle}>
                    About Us – Vivaha Sangamam
                </Typography>
                <Typography sx={textStyle}>
                    Established in 2022, Vivaha Sangamam Organization has grown into one
                    of <b>South India’s</b> most trusted matchmaking organizations, dedicated to
                    connecting families with compassion, professionalism, and cultural
                    understanding. With over 3 years of experience, we continue to fulfill
                    our mission of <strong>"Connecting Hearts, Uniting Soul."</strong>
                </Typography>
            </Box>

            {/* JOURNEY & ACHIEVEMENTS */}
            <Box sx={sectionStyle}>
                <Typography variant="h5" sx={subHeadingStyle}>
                    Our Journey & Achievements
                </Typography>
                <Grid container spacing={3} justifyContent="center">
                    {[
                        {
                            icon: <Event sx={cardIcon} />,
                            text: "50+ Successful Suyamvaram Matchmaking Events",
                        },
                        {
                            icon: <People sx={cardIcon} />,
                            text: "5000+ Verified Profiles across various communities",
                        },
                        {
                            icon: <SupportAgent sx={cardIcon} />,
                            text: "500+ Successful Marriages over the years",
                        },
                        {
                            icon: <Stars sx={cardIcon} />,
                            text: "20+ Astro Events & Direct Astrology Classes",
                        },
                        {
                            icon: <Public sx={cardIcon} />,
                            text: "Exclusive NRI Profiles from all over the world",
                        },
                        {
                            icon: <WorkspacePremium sx={cardIcon} />,
                            text: "Exclusive Doctor Profiles (MBBS)",
                        },
                        {
                            icon: <StarBorder sx={cardIcon} />,
                            text: "Expertise in Re-Marriage matchmaking",
                        },
                        {
                            icon: <Verified sx={cardIcon} />,
                            text: "No Caste Bar – we welcome profiles from all communities",
                        },
                        {
                            icon: <PersonSearch sx={cardIcon} />,
                            text: "Panel of Leading Astrologers & Experts offering horoscope suggestions",
                        },
                    ].map((item, index) => (
                        <Grid item xs={12} md={4} key={index} sx={{ width: "100%", maxWidth: "320px" }}>
                            <Card elevation={1} sx={achievementCard}>
                                <CardContent>
                                    {item.icon}
                                    <Typography sx={textStyle}>{item.text}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* DEDICATED SERVICES */}
            <Box sx={sectionStyle}>
                <Typography variant="h5" sx={subHeadingStyle}>
                    Our Dedicated Services
                </Typography>

                <Typography sx={textStyle}>
                    <strong>365 Days of Office Support:</strong> Clients can visit our office
                    any day of the year to receive personal guidance and explore profiles in
                    detail.
                </Typography>

                <Typography sx={textStyle}>
                    <strong>Suyamvaram Events Across South India:</strong> We conduct 2–3
                    physical Suyamvaram events every month across various <strong>South Indian </strong>
                    cities, enabling families to meet and interact in real-time.
                </Typography>

                <Typography sx={textStyle}>
                    <strong>Personal Assisted Services:</strong> Every client is assigned a
                    dedicated Customer Relationship Manager who understands preferences,
                    shortlists suitable matches, coordinates communication, and guides until
                    a successful match is completed.
                </Typography>
            </Box>

             <Box sx={{ mt: 6, position: "relative" }}>
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontFamily:"quicksand",
          color: "#BF0603",
          mb: 4,
          fontSize: { xs: "24px", md: "38px" }
        }}
      >
        What Our Customers Say
      </Typography>

      {/* Wrapper for arrows + swiper */}
      <Box sx={{ position: "relative" }}>

        {/* LEFT ARROW */}
        <IconButton
          className="swiper-button-prev"
          sx={{
            position: "absolute",
            top: "50%",
            left: "-25px",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "#faf6f2",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            width: 35,
            height: 35,
            "&:hover": { backgroundColor: "#faf6f2" },
          }}
        >
          <ArrowBackIosNew sx={{ color: "#000", fontSize: 20 }} />
        </IconButton>

        {/* RIGHT ARROW */}
        <IconButton
          className="swiper-button-next"
          sx={{
            position: "absolute",
            top: "50%",
            right: "-25px",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "#faf6f2",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            width: 35,
            height: 35,
            "&:hover": { backgroundColor: "#faf6f2" },
          }}
        >
          <ArrowForwardIos sx={{ color: "#000", fontSize: 20 }} />
        </IconButton>

        {/* SWIPER */}
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={24}
          slidesPerView={3}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            1440: { slidesPerView: 3 },
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            425: { slidesPerView: 1 },
            375: { slidesPerView: 1 },
          }}
          style={{ paddingBottom: "40px" }}
        >
          {reviews.map((item, i) => (
            <SwiperSlide key={i}>
              <Card
                sx={{
                  width: 350,
                  height: 320,
                  mx: "auto",
                  borderRadius: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  backgroundColor: "#faf6f2",
                  display: "flex",
                  flexDirection: "column",
                  p: 2,
                }}
              >
                <CardContent>
                  
                  {/* Header: Avatar + Name */}
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Avatar
                      sx={{
                        bgcolor: "#f35b04",
                        width: 52,
                        height: 52,
                        mr: 2,
                        fontSize: 20,
                      }}
                    >
                      {item.name.charAt(0)}
                    </Avatar>

                    <Box>
                      <Typography sx={{ fontWeight: 700, color: "#000" }}>
                        {item.name}
                      </Typography>
                      {/* <Typography sx={{ fontSize: "0.75rem", color: "#555" }}>
                        {item.time}
                      </Typography> */}
                    </Box>
                  </Box>

                  {/* Stars */}
                  <Box sx={{ display: "flex", mb: 1 }}>
                    {Array.from({ length: item.stars }).map((_, s) => (
                      <StarIcon
                        key={s}
                        sx={{ color: "#f35b04", fontSize: 20 }}
                      />
                    ))}
                  </Box>

                  {/* Review Text */}
                  <Typography
                    sx={{
                      color: "#333",
                      fontSize: "0.9rem",
                      lineHeight: 1.5,
                    }}
                  >
                    {item.text}
                  </Typography>
                </CardContent>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>

            {/* ASTRO EVENTS & GUIDANCE */}
            <Box sx={sectionStyle}>
                <Typography variant="h5" sx={subHeadingStyle}>
                    Astro Events & Expert Guidance
                </Typography>
                <Typography sx={textStyle}>
                    Vivaha Sangamam organizes multiple Astro Events with experienced
                    astrologers offering horoscope checks, compatibility insights, marriage
                    solutions, and personalized guidance.
                </Typography>
            </Box>

            {/* OUR PROMISE */}
            <Box sx={sectionStyle}>
                <Typography variant="h5" sx={subHeadingStyle}>
                    Our Promise
                </Typography>
                <Typography sx={textStyle}>
                    At Vivaha Sangamam Organization, we believe marriage is a sacred
                    journey built on trust, compatibility, and mutual respect. Our
                    commitment is to guide families with sincerity, warmth, and the highest
                    level of professionalism.
                </Typography>
            </Box>
        </Box>
    );
}